import { Application } from 'app/shared/services/app/application/application.model';

export const sysNames: string[] = ['mobile_user', 'business_user', 'business_owner', 'app_manager', 'super_admin'];
const englishNames: string[] = ['User', 'Manager', 'Owner', 'Admin', 'Super Admin'];
export enum RoleType { User, Manager, Owner, Admin, SuperAdmin };

export class UserApplicationProperties {
  id: number = Math.floor(Math.random() * 10000);
  level: RoleType;
  application: Application;

  constructor(role: string, application?: Application) {
    this.level = sysNames.indexOf(role);
    this.application = application || null;
  }

  get sysName() {
    return sysNames[this.level];
  }

  toString() {
    return englishNames[this.level];
  }

  static getSysNameForRoleLevel(level: RoleType) {
    return sysNames[level];
  }

  static getEnglishNameForRoleLevel(level: RoleType) {
    return englishNames[level];
  }

  toJson() {
    return {
      app: this.application ? this.application.sys_name : null,
      role: this.sysName
    }
  }

  copy() {
    return new UserApplicationProperties(this.sysName, this.application);
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/services/user/user-application-properties.model.ts